export const tr = {
    'banner-id': '№ {bannerId}'
};
